/**
 * 发货类型(1:大件普通 0:大件fba 2:小件  3:次品退货 4:异常退货 5:仓库调拨)
 * **/
export const deliveryTypes = {
    // FBA发货
    "largeBag": 1,
    "FBA": 0,
    "smallBag": 2,

}

/**
 * 发货状态(0:待处理 1:拣货中 2:打标中 3:打包中 4:打包完成 5:已发货)
 * **/
export const deliveryStatus = {
    "waitUp": -1,
    "toBeProcessed": 0,
    "picking": 1,
    "marking": 2,
    "buildingBag": 3,
    "builtBag": 4,
    "shipped": 5,
    "abandoned": undefined
}

/**
 * 废弃标签
 * **/
export const abandonFlagList = {
  "waitUp": 0,
  "toBeProcessed": 0,
  "picking": 0,
  "marking": 0,
  "buildingBag": 0,
  "builtBag": 0,
  "shipped": 0,
  "abandoned": 1
}